import PublicLayout from "@/components/layouts/bootstrap/PublicLayout";
import Link from "next/link";
import { Image } from "react-bootstrap";

export default function IndustryQuestion()
{

    return (
        <>
            <section className="hero-reseller d-flex align-items-center text-white">
                <div className="container hero-inner">
                    <div>
                        <h1>Leadership isn’t about having all the answers — it’s about asking the right questions.</h1>
                        <p>
                            Inside each volume, you’ll discover expert curated questions that challenge conventional thinking, inspire meaningful conversations, and spark transformation in your business. This includes thoughtful Mental Health Questions designed to foster resilience and well-being, as well as specialised questions for the FIFO (Fly-In, Fly-Out) industry to address unique challenges faced by its workforce. Whether you’re scaling a company, developing teams, driving culture change, or leading digital transformation, this library helps you uncover the insight gaps that unlock exponential growth. Use it as a leadership playbook, a team workshop toolkit, or a catalyst for boardroom discussion — wherever better decisions begin.
                        </p>
                    </div>
                </div>
            </section>

            <section className="py-5">
                <div className="container industry">
                    <div className="d-flex justify-content-between align-items-center mb-5">
                        <Link href="/industry " className="nav-link text-light btn demo-btn">
                            Back
                        </Link>

                        <h2 className="fw-bold text-teal text-center flex-grow-1 mb-0 secondaryColor">
                            Leaders Questions by Experts
                        </h2>
                        <div className="width90"></div>
                    </div>

                    <div className="row g-4 justify-content-center">
                        <div className="col-12 col-sm-6 col-md-3 col-lg-3 zIndex9999" >
                            <Link href={{ pathname: "/industry_questions_view", query: { from: "Mental Health Industry" } }}>
                                <div className="industry-card shadow">
                                    <Image src="/industry/mental-health-industry-polling.png" alt="Mental Health Industry" />
                                    <div className="industry-footer">Mental Health Industry</div>
                                </div>
                            </Link>
                        </div>
                        <div className="col-12 col-sm-6 col-md-3 col-lg-3">
                            <Link href={{ pathname: "/industry_questions_view", query: { from: "Mental Health FIFO" } }}>
                                <div className="industry-card shadow">
                                    <Image src="/industry/mental-health-fifo-polling.png" alt="Mental Health FIFO" />
                                    <div className="industry-footer">Mental Health FIFO</div>
                                </div>
                            </Link>
                        </div>
                        <div className="col-12 col-sm-6 col-md-3 col-lg-3">
                            <Link href={{ pathname: "/industry_questions_view", query: { from: "Executive Leadership" } }}>
                                <div className="industry-card shadow">
                                    <Image src="/industry/executive-leadership-polling.png" alt="Business Leaders" />
                                    <div className="industry-footer">Executive Leadership</div>
                                </div>
                            </Link>
                        </div>

                        <div className="col-12 col-sm-6 col-md-3 col-lg-3">
                            <Link href={{ pathname: "/industry_questions_view", query: { from: "High Performing Team - MGT" } }}>
                                <div className="industry-card shadow">
                                    <Image src="/public/high-performing-team-polling.png" alt="High Performing Team" />
                                    <div className="industry-footer">High Performing Team - MGT</div>
                                </div>
                            </Link>
                        </div>

                        <div className="col-12 col-sm-6 col-md-3 col-lg-3">
                            <Link href={{ pathname: "/industry_questions_view", query: { from: "Vision & Strategy" } }}>
                                <div className="industry-card shadow">
                                    <Image src="/industry/education-polling-category.png" alt="Consultants" />
                                    <div className="industry-footer">Vision & Strategy </div>
                                </div>
                            </Link>
                        </div>

                        <div className="col-12 col-sm-6 col-md-3 col-lg-3">
                            <Link href={{ pathname: "/industry_questions_view", query: { from: "Customer Market & Focus" } }}>
                                <div className="industry-card shadow">
                                    <Image src="/public/workplace-culture-polling.png" alt="Customer Market & Focus" />
                                    <div className="industry-footer">Customer Market & Focus</div>
                                </div>
                            </Link>
                        </div>

                        <div className="col-12 col-sm-6 col-md-3 col-lg-3">
                            <Link href={{ pathname: "/industry_questions_view", query: { from: "Growth & Scaling" } }}>
                                <div className="industry-card shadow">
                                    <Image src="/public/business-growth-polling-background.png" alt="Growth" />
                                    <div className="industry-footer">Growth & Scaling</div>
                                </div>
                            </Link>
                        </div>

                        <div className="col-12 col-sm-6 col-md-3 col-lg-3">
                            <Link href={{ pathname: "/industry_questions_view", query: { from: "Innovation & Future Trends" } }}>
                                <div className="industry-card shadow">
                                    <Image src="/public/innovation-trends-polling.png" alt="Innovation" />
                                    <div className="industry-footer">Innovation & Future Trends </div>
                                </div>
                            </Link>
                        </div>

                        <div className="col-12 col-sm-6 col-md-3 col-lg-3">
                            <Link href={{ pathname: "/industry_questions_view", query: { from: "Resilience & Adaptability" } }}>
                                <div className="industry-card shadow">
                                    <Image src="/industry/healthcare-polling-category.png" alt="Consultants" />
                                    <div className="industry-footer">Resilience & Adaptability</div>
                                </div>
                            </Link>
                        </div>
                        <div className="col-12 col-sm-6 col-md-3 col-lg-3">
                            <Link href={{ pathname: "/industry_questions_view", query: { from: "Technology & Digital" } }}>
                                <div className="industry-card shadow">
                                    <Image src="/industry/government-polling-category.png" alt="Government" />
                                    <div className="industry-footer">Technology & Digital</div>
                                </div>
                            </Link>
                        </div>
                        <div className="col-12 col-sm-6 col-md-3 col-lg-3">
                            <Link href={{ pathname: "/industry_questions_view", query: { from: "Financial & Operational Excellence" } }}>
                                <div className="industry-card shadow">
                                    <Image src="/industry/events-polling-category.png" alt="Events" />
                                    <div className="industry-footer">Financial & Operational Excellence</div>
                                </div>
                            </Link>
                        </div>
                        <div className="col-12 col-sm-6 col-md-3 col-lg-3">
                            <Link href={{ pathname: "/industry_questions_view", query: { from: "Sustainability & Purpose" } }}>
                                <div className="industry-card shadow">
                                    <Image src="/industry/consultants-polling-category.png" alt="Consultants" />
                                    <div className="industry-footer">Sustainability & Purpose</div>
                                </div>
                            </Link>
                        </div>
                        <div className="col-12 col-sm-6 col-md-3 col-lg-3">
                            <Link href={{ pathname: "/industry_questions_view", query: { from: "Workplace Culture" } }}>
                                <div className="industry-card shadow">
                                    <Image src="/public/workplace-culture-polling.png" alt="Workplace Culture" />
                                    <div className="industry-footer">Workplace Culture</div>
                                </div>
                            </Link>
                        </div>

                    </div>
                </div>
            </section>
        </>
    )
}
IndustryQuestion.getLayout = (page) => <PublicLayout>{page}</PublicLayout>;